import React from 'react';
import ReactMarkdown from 'react-markdown';
import ChevronIcon from '../../../../../icons/icon-chevron.svg';


const renderDropDownChildren = function renderDropDownChildrenOpcoNav(
  locationSelected,
) {
  const locationSelectedDisplay = locationSelected || 'Choose One';

  return (
    <div className="opco-nav-form__current-selection" aria-selected="true">
      <ReactMarkdown
        source={locationSelectedDisplay}
        renderers={{ paragraph: props => <div {...props} /> }}
      />
      <ChevronIcon className="opco-nav-form__ev-arrow" />
    </div>
  );
};

export default renderDropDownChildren;
